/**
 * PillTrigger — a rounded pill button for dropdown/menu triggers.
 *
 * Used for inline-changeable values like classification, status, etc.
 * Consistent contrast on linen backgrounds using foreground opacity.
 *
 * Usage:
 *   <DropdownMenu>
 *     <DropdownMenuTrigger asChild>
 *       <PillTrigger>Legislation <ChevronDown /></PillTrigger>
 *     </DropdownMenuTrigger>
 *     ...
 *   </DropdownMenu>
 */

import { forwardRef } from "react";
import { cn } from "@/lib/utils";

const PillTrigger = forwardRef<
  HTMLButtonElement,
  React.ComponentProps<"button">
>(({ className, ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    className={cn(
      "inline-flex items-center gap-1.5 cursor-pointer rounded-full px-3.5 py-1.5",
      "text-sm font-medium",
      "bg-foreground/[0.06] hover:bg-foreground/[0.10]",
      "transition-colors outline-none",
      "focus-visible:ring-2 focus-visible:ring-ring",
      className,
    )}
    {...props}
  />
));

PillTrigger.displayName = "PillTrigger";

export { PillTrigger };
